import { InjectableClass } from '@fino/lib-injection';

export class InboxDocumentService extends InjectableClass {
  constructor(DocumentTypes, DocumentStatus, IbanPrefix, InboxIbanService) {
    'ngInject';
    super({
      DocumentTypes,
      DocumentStatus,
      IbanPrefix,
      InboxIbanService,
    });

    this.selectedDocument = {};
  }

  get envelope() {
    return this.innerTempDocument ? this.innerTempDocument.envelope : {};
  }

  get docImageUrl() {
    // remove host since courier.kwh... causes CORS issues

    return this.selectedDocument && this.selectedDocument.docUrl
      ? new URL(this.selectedDocument.docUrl).pathname
      : '';
  }

  set selectedDocument(documentToSet) {
    this.innerTempDocument = documentToSet;
  }

  get selectedDocument() {
    return this.innerTempDocument;
  }

  get isWarrant() {
    if (this.innerTempDocument && this.envelope) {
      return this.envelope.documentType === this.DocumentTypes.WARRANT;
    }
    return false;
  }

  removePrefixFromValue(prefix, value) {
    return this.InboxIbanService.removePrefixFromValue(prefix, value);
  }
}
